export const CONFIG_STORE_KEY = 'config';
export const CONFIG_STORE_API_KEY = 'configApi';
export const CONFIG_GET_API = '/contracts/uiconfig';
